const videoElements = document.querySelectorAll('.text-with-video, .video-with-headline');

try {
    window.onYouTubeIframeAPIReady = function () {
        videoElements.forEach((videoElement) => {
            const playButton = videoElement.querySelector('.video-play-button');
            const previewImage = videoElement.querySelector('.video-preview');
            const wrapper = videoElement.querySelector('.video');

            if (wrapper) {
                const videoId = wrapper.dataset.videoId;
                const playerEl = wrapper.querySelector('.video-player');
                const usercentricsDisclaimer = wrapper.querySelector('.usercentrics-disclaimer');
                let player;

                if (usercentricsDisclaimer) {
                    wrapper.removeChild(usercentricsDisclaimer);
                }

                if (playButton && previewImage) {
                    showPlayButtonAndPreviewImage(playButton, previewImage);

                    playButton.addEventListener('click', () => {
                        if (previewImage && wrapper && videoId && playerEl) {
                            player = new YT.Player(playerEl, {
                                videoId: videoId,
                                events: {
                                    onReady: onPlayerReady,
                                },
                            });
                            hidePlayButtonAndPreviewImage(playButton, previewImage);
                        }
                    });
                } else {
                    if (wrapper && videoId && playerEl) {
                        player = new YT.Player(playerEl, {
                            videoId: videoId,
                        });
                    }
                }
            }
        });
    };

    window.addEventListener('UC_UI_INITIALIZED', () => {
        loadVideoContent();
    });
    window.addEventListener('UC_UI_CMP_EVENT', () => {
        loadVideoContent();
    });
    window.addEventListener('consent_status', () => {
        loadVideoContent();
    });
} catch (e) {
    console.error(e);
}

function loadVideoContent() {
    if (videoElements.length > 0) {
        const youTubeAllowed = getUsercentricsMapConsentStatus();
        if (!youTubeAllowed) {
            showUsercentricsDisclaimer();
        } else {
            loadYoutubeVideos();
        }
    }
}

function getUsercentricsMapConsentStatus() {
    // This is the "Template ID" of the "YouTube Video" service in the usercentrics dashboard under "Service Settings".
    const youTubeVideoTemplateId = 'BJz7qNsdj-7';
    return window.UC_UI?.getServicesBaseInfo()?.find((service) => service.id === youTubeVideoTemplateId)?.consent
        ?.status;
}

function showUsercentricsDisclaimer() {
    videoElements.forEach((videoElement) => {
        const playButton = videoElement.querySelector('.video-play-button');
        const previewImage = videoElement.querySelector('.video-preview');
        const wrapper = videoElement.querySelector('.video');

        if (!wrapper.querySelector('.usercentrics-disclaimer')) {
            const contentElement = wrapper.closest('.video-element');

            if (!contentElement) {
                return;
            }

            const disclaimerTemplate = contentElement.querySelector('.usercentrics-disclaimer-template');

            if (disclaimerTemplate) {
                if (playButton && previewImage) {
                    hidePlayButtonAndPreviewImage(playButton, previewImage);
                }
                wrapper.appendChild(disclaimerTemplate.content.cloneNode(true));
            } else {
                console.error('No Usercentrics disclaimer template found.');
            }
        }
    });
}

function loadYoutubeVideos() {
    window.dataLayer = window.dataLayer || [];

    if (!document.head.querySelector('script[src="https://www.youtube.com/iframe_api"]')) {
        const script = document.createElement('script');
        script.async = true;
        script.src = 'https://www.youtube.com/iframe_api';
        document.head.appendChild(script);
    }
}

function onPlayerReady(event) {
    event.target.playVideo();
}

function hidePlayButtonAndPreviewImage(playButton, previewImage) {
    if (playButton && previewImage) {
        playButton.style.display = 'none';
        previewImage.style.display = 'none';
    }
}

function showPlayButtonAndPreviewImage(playButton, previewImage) {
    if (playButton && previewImage) {
        playButton.style.removeProperty('display');
        previewImage.style.removeProperty('display');
    }
}
